module.exports = __webpack_public_path__ + "static/swag-fc5211c96df3145619919353cf3045a7.png";